import { createSlice } from "@reduxjs/toolkit";

export const DialogType = createSlice({
  name: "dialogType",
  initialState: {
    dialogType: "service",
  },
  reducers: {
    setDialogType: (state, action) => {
      state.dialogType = action.payload;
    },
  },
});

export const { setDialogType } = DialogType.actions;

export default DialogType.reducer;
